module.exports = __webpack_public_path__ + "static/media/8.813986ea.jpg";